export default [
    {
        path: 'rego/customer-detail',
        name: 'customer-detail',
        component: () => import('@/views/customer-detail/Index'),
        meta: {
            step: 3
        }
    },
]